import { render, staticRenderFns } from "./ApproveDesktopHeader.vue?vue&type=template&id=31891dc0"
import script from "./ApproveDesktopHeader.vue?vue&type=script&lang=js"
export * from "./ApproveDesktopHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports